import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import CreateTemplateManual from './CreateTemplateManual';
import ExtractTemplateFromPDF from './ExtractTemplateFromPDF';
import MyTemplatesList from '../components/MyTemplatesList';

/**
 * Combined Templates screen for COE.
 * A single tab bar — Create Template · Extract Template · My Templates — wrapping
 * the existing builders in "embedded" mode (their own headers/tab bars hidden) so
 * there are no duplicate/nested tabs.
 *
 * Tab can be controlled via ?tab=create | extract | my query parameter.
 */
export default function COEManageTemplates() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get('tab') || 'create');

  const switchTab = (key) => {
    setTab(key);
    setSearchParams({ tab: key }, { replace: true });
  };

  const tabBtn = (key, label) => (
    <button
      key={key}
      onClick={() => switchTab(key)}
      style={{
        padding: '0.7rem 1.4rem',
        border: 'none',
        background: 'none',
        cursor: 'pointer',
        fontSize: '0.9rem',
        fontWeight: tab === key ? 700 : 500,
        color: tab === key ? 'var(--primary)' : 'var(--text-secondary)',
        borderBottom: tab === key ? '2px solid var(--primary)' : '2px solid transparent',
        marginBottom: '-2px',
      }}
    >
      {label}
    </button>
  );

  return (
    <div style={{ padding: '1.5rem' }}>
      <h1 style={{ margin: '0 0 1rem', fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-primary)' }}>Templates</h1>
      <div style={{ display: 'flex', gap: '0.25rem', borderBottom: '2px solid var(--border-color)', marginBottom: '1rem' }}>
        {tabBtn('create', 'Create Template')}
        {tabBtn('extract', 'Extract Template')}
        {tabBtn('my', 'My Templates')}
      </div>
      <div>
        {tab === 'create' && <CreateTemplateManual embedded />}
        {tab === 'extract' && <ExtractTemplateFromPDF embedded />}
        {tab === 'my' && <MyTemplatesList />}
      </div>
    </div>
  );
}
